import { render, staticRenderFns } from "./PPFunDetails.vue?vue&type=template&id=7bb832d9"
import script from "./PPFunDetails.vue?vue&type=script&lang=js"
export * from "./PPFunDetails.vue?vue&type=script&lang=js"
import style0 from "./PPFunDetails.vue?vue&type=style&index=0&id=7bb832d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports